import type CardProperties from './Card.properties.ts';
import React from 'react';
import styles from './Card.module.css';

export default function CardView(props: CardProperties) {
  return (
    <div className={styles.card} onClick={props.onClick}>
      <props.icon className={styles.cardIcon} />
      <div className={styles.cardContent}>{props.label}</div>
    </div>
  );
}
